// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"591":"81ef8276","668":"36744fde","787":"16f526d4","819":"fb8fbcea"}[chunkId] + ".chunk.js";
};